module.exports = __webpack_public_path__ + "img/cxx.6c951b91.png";